
import { defineComponent } from 'vue';
import api from '@/api/admin/healths';
import utils from '@/utils';
import { IHealth } from '@/types/models';

interface IState {
  healths: IHealth[];
}

export default defineComponent({
  name: 'Healths',
  data() {
    return {
      healths: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        if (!res) return;
        this.healths = res.healths;
      });
    },

    apiDelete() {
      api.delete((res) => {
        if (!res) return;
        utils.success('健康检查删除成功！');
        this.apiGet();
      });
    },

    btnDeleteAllClick() {
      utils.alertDelete(
        {
          title: '删除全部健康检查',
          text: '此操作将删除全部健康检查，确定吗？',
          button: '确认删除',
        },
        () => {
          this.apiDelete();
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
